<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button class="btn-primary" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button class="btn-primary" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>

    <div class="w-1/2">
      <mat-label>API LOG查詢條件</mat-label>

      <!-- 日期範圍 -->
      <app-jkdaterange
        label="查詢日期"
        [(valueA)]="filterOpt.startDate"
        [(valueB)]="filterOpt.endDate"
        [showClearButton]="true">
      </app-jkdaterange>

      <!-- HTTP方法 -->
      <app-jkcombobox
        label="HTTP方法"
        [(value)]="filterOpt.method"
        [items]="methodList"
        [showClearButton]="true">
      </app-jkcombobox>

      <!-- HTTP狀態碼 -->
      <app-jkcombobox
        label="HTTP狀態碼"
        [(value)]="filterOpt.statusCode"
        [items]="statusCodeList"
        [showClearButton]="true">
      </app-jkcombobox>

      <!-- 請求URL -->
      <app-jkedit
        [visible]="true"
        [label]="'請求URL'"
        [required]="false"
        [(value)]="filterOpt.url"
        [width]="'100'"
        [placeholder]="'輸入URL關鍵字'">
      </app-jkedit>

      <!-- 客戶端IP -->
      <app-jkedit
        [visible]="true"
        [label]="'客戶端IP'"
        [required]="false"
        [(value)]="filterOpt.clientIp"
        [width]="'60'">
      </app-jkedit>

      <!-- 用戶ID -->
      <app-jkedit
        [visible]="true"
        [label]="'用戶ID'"
        [required]="false"
        [(value)]="filterOpt.userId"
        [width]="'60'">
      </app-jkedit>

      <!-- 排序設定 -->
      <app-jkcombobox
        label="排序欄位"
        [(value)]="filterOpt.sortBy"
        [items]="sortByList">
      </app-jkcombobox>

      <app-jkcombobox
        label="排序方向"
        [(value)]="filterOpt.sortOrder"
        [items]="sortOrderList">
      </app-jkcombobox>

      <!-- 分頁設定 -->
      <app-jkedit
        [visible]="true"
        [label]="'每頁筆數'"
        [required]="false"
        [(value)]="filterOpt.pageSize"
        [width]="'20'"
        type="number">
      </app-jkedit>
    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="查詢結果">
    <app-jkgridwin #jkgridwin
      (afterGridReady)="afterGridReady($event)">
    </app-jkgridwin>
    <label>{{logMessage}}</label>
  </mat-tab>
</mat-tab-group>
